import React from 'react';
import { useFormContext } from 'react-hook-form';
import style from './fields.module.scss';
// import FormTextField from 'controls/textField/formTextField';
import { AuthType } from 'pages/login/types';
import { getErrorsProps } from 'utils/utils';
import OutlinedLabeledTextField from 'controls/textField/outlinedLabeledTextField';
import OutlinedPasswordTextField from 'controls/password/outlinedPasswordTextField';

export default function Fields(props: { type: AuthType }) {
  const {
    formState: { errors },
  } = useFormContext();

  const adaptedErrors = getErrorsProps(errors);
  return (
    <div className={style.container}>
      {props.type === 'signup' && (
        <>
          <OutlinedLabeledTextField
            name="name"
            rules={{ required: true }}
            formLabel="Имя"
            textFieldProps={{
              InputProps: {
                placeholder: 'Ваше имя',
              },
              ...adaptedErrors['name'],
            }}
          ></OutlinedLabeledTextField>

          <OutlinedLabeledTextField
            name="surname"
            rules={{ required: true }}
            formLabel="Фамилия"
            textFieldProps={{
              InputProps: {
                placeholder: 'Ваша фамилия',
              },
              ...adaptedErrors['surname'],
            }}
          ></OutlinedLabeledTextField>
        </>
      )}

      <OutlinedLabeledTextField
        name="email"
        formLabel="E-mail"
        textFieldProps={{
          id: 'email',
          InputProps: {
            placeholder: 'example@transport.mos.ru',
          },
          ...adaptedErrors['email'],
        }}
      ></OutlinedLabeledTextField>

      {props.type === 'signup' && (
        <OutlinedLabeledTextField
          name="organization"
          rules={{ required: true }}
          formLabel="Название организации"
          textFieldProps={{
            id: 'password',
            InputProps: {
              placeholder: 'Например: ЦОДД',
            },
            ...adaptedErrors['organization'],
          }}
        ></OutlinedLabeledTextField>
      )}

      <OutlinedPasswordTextField
        name="password"
        rules={{ required: true }}
        formLabel="Пароль"
        textFieldProps={{
          ...adaptedErrors['password'],
        }}
      ></OutlinedPasswordTextField>
    </div>
  );
}
